jQuery(document).ready(function ($) {
  var logo = document.getElementById('mu-portal-logo');
  var portalName = document.getElementById('mu-portal-name');
  if (logo && portalName) {
    var hideBrokenLogo = function () {
      logo.removeEventListener('error', hideBrokenLogo);
      logo.style.display = 'none';
    };

    logo.addEventListener('error', hideBrokenLogo);
    if (logo.complete && logo.naturalWidth === 0) {
      hideBrokenLogo();
    }
  }

  // vlastní select Select2 ( https://select2.org/ )
  if ($('.mu-js-select').length) {
    $('.mu-js-select').select2({
      language: 'cs',
    });
  }

  // select - vybraná položka
  if ($('.mu-js-select-selected').length) {
    $('.mu-js-select-selected').select2({
      language: 'cs',
      selectionCssClass: 'is-selected',
      width: 'resolve',
    });
  }

  // select - položka s vyhledáváním
  if ($('.mu-js-select-search').length) {
    $('.mu-js-select-search').select2({
      language: 'cs',
      dropdownCssClass: 'has-search',
      width: 'resolve',
    });
  }

  // select - vybraná položka s vyhledáváním
  if ($('.mu-js-select-search-selected').length) {
    $('.mu-js-select-search-selected').select2({
      language: 'cs',
      selectionCssClass: 'is-selected',
      dropdownCssClass: 'has-search',
      width: 'resolve',
    });
  }

  // select - řešení multiple selectu
  if ($('.mu-js-select-multi').length) {
    $('.mu-js-select-multi').on('change', function () {
      var selectActual = $(this).val();
      var selectConnect = '#' + $(this).data('multi');
      // skrytý multiselect obsahuje jen vybrané hodnoty, novou volbu do něj přidáme
      var $connect = $(selectConnect);
      var $option = $connect.find('option').filter(function () {
        return this.value === selectActual;
      });
      if (!$option.length && selectActual) {
        $option = $('<option>').val(selectActual).text(selectActual);
        $connect.append($option);
      }
      $option.prop('selected', true);
      // nastavení stránkování na 1
      $('#strana').val(1);
      // odeslání formuláře
      $('#sbirky').submit();
    });
  }

  // select - datum se sliderem
  if ($('.mu-js-date-slider').length) {
    $('.mu-js-date-slider .mu-select-false__input').on('click', function () {
      $(this).next('.mu-slider').toggleClass('is-open');
    });
  }

  // select - odeslání formuláře sbírky po změně
  $('.mu-js-submit-collection').on('change', function () {
    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // select - odeslání formuláře kolekce po změně
  $('.mu-js-submit-collist').on('change', function () {
    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#collist').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.mu-js-form-select').on('change', function () {
    if ($(this).data('input') === 'pl') {
      var pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set('pl', $(this).val());
      pageUrl.searchParams.set('strana', '1');
      pageUrl.searchParams.delete('more');
      window.location.href = pageUrl.toString();
      return;
    }

    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.mu-js-form-input').on('change', function () {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - stránkování
  $('.mu-js-form-page').on('change', function () {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.mu-js-form-checkbox').on('change', function () {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = '0';

    if ($(this).prop('checked')) {
      inputValue = '1';
    }

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // přepínač "Pouze s obrázkem" v demo-test: zachová ostatní filtry v URL
  $('.mu-js-toggle-jo').on('change', function () {
    var nextUrl = new URL(window.location.href);

    if ($(this).prop('checked')) {
      nextUrl.searchParams.set('jo', '1');
    } else {
      nextUrl.searchParams.set('jo', '0');
    }

    nextUrl.searchParams.set('strana', '1');
    nextUrl.searchParams.delete('more');
    nextUrl.searchParams.delete('do');
    nextUrl.searchParams.delete('check');

    var nextPathAndSearch = nextUrl.pathname + nextUrl.search;
    var currentPathAndSearch =
      window.location.pathname + window.location.search;

    if (nextPathAndSearch !== currentPathAndSearch) {
      window.location.href = nextPathAndSearch;
    }
  });

  function muScrollOffset() {
    var header = document.querySelector('.header.mu-sticky-header--fixed');
    return (header ? header.offsetHeight : 0) + 12;
  }

  jQuery(document).ready(function ($) {
    function updatePaginationLinks(currentPage) {
      $('.mu-meta__paging').each(function () {
        var $paging = $(this);
        var $prev = $paging.find('.mu-meta__prev');
        var $next = $paging.find('.mu-meta__next');

        if ($prev.length > 0) {
          var prevHref = $prev.attr('href');
          if (prevHref) {
            var prevUrl = new URL(prevHref, window.location.origin);
            prevUrl.searchParams.set(
              'strana',
              String(Math.max(currentPage - 1, 1))
            );
            prevUrl.searchParams.set('more', '0');
            $prev.attr(
              'href',
              prevUrl.pathname + prevUrl.search + prevUrl.hash
            );
          }
        }

        if ($next.length > 0) {
          var nextHref = $next.attr('href');
          if (nextHref) {
            var nextUrl = new URL(nextHref, window.location.origin);
            nextUrl.searchParams.set('strana', String(currentPage + 1));
            nextUrl.searchParams.set('more', '0');
            $next.attr(
              'href',
              nextUrl.pathname + nextUrl.search + nextUrl.hash
            );
          }
        }
      });
    }

    $('.mu-js-load-more').on('click', function (e) {
      var $btn = $(this);
      var $list = $('#mu-items-list');
      if ($list.length === 0) {
        return;
      }

      e.preventDefault();

      var href = $btn.attr('href').split('#')[0];
      var sep = href.indexOf('?') === -1 ? '?' : '&';
      var offset = parseInt($btn.data('offset'), 10) || 0;
      var step = parseInt($btn.data('step'), 10) || 12;
      var previousItemCount = $list.children().length;
      var currentPage = parseInt($('#strana').val(), 10) || 1;

      $btn.prop('disabled', true).addClass('is-loading');

      $.get(href + sep + 'ajaxMore=1&offset=' + offset)
        .done(function (html, status, xhr) {
          $list.append(html);

          var $newItems = $list.children().slice(previousItemCount);
          if ($newItems.length > 0) {
            currentPage += 1;
            $('#strana').val(currentPage);
            $('.mu-js-form-page').val(currentPage);
            updatePaginationLinks(currentPage);

            var targetScrollTop = Math.max(
              $newItems.first().offset().top - muScrollOffset(),
              0
            );
            $('html, body')
              .stop(true)
              .animate({ scrollTop: targetScrollTop }, 300);
          }

          var nextOffset = offset + step;
          $btn.data('offset', nextOffset);
          $btn.attr(
            'href',
            href.replace(/([?&]more=)\d+/, '$1' + (nextOffset + step))
          );

          if (xhr.getResponseHeader('X-Has-More') === '1') {
            $btn.prop('disabled', false).removeClass('is-loading');
          } else {
            $btn.closest('.mu-meta__button').remove();
          }
        })
        .fail(function () {
          $btn.prop('disabled', false).removeClass('is-loading');
        });
    });
  });

  jQuery(document).ready(function ($) {
    var section = '#mu-collection-items';

    function withParams(href, extra) {
      var url = new URL(href.split('#')[0], window.location.origin);
      Object.keys(extra).forEach(function (key) {
        url.searchParams.set(key, extra[key]);
      });
      return url.pathname + url.search;
    }

    function scrollTo($element) {
      var target = Math.max($element.offset().top - muScrollOffset(), 0);
      $('html, body').stop(true).animate({ scrollTop: target }, 300);
    }

    $(document).on(
      'click',
      section + ' .mu-meta__prev, ' + section + ' .mu-meta__next',
      function (e) {
        var $section = $(section);
        var href = $(this).attr('href');
        if (!href) {
          return;
        }

        e.preventDefault();
        $section.addClass('is-loading');

        $.get(withParams(href, { ajaxColPage: 1 }))
          .done(function (html) {
            $section.html(html);
            if (window.history && window.history.pushState) {
              window.history.pushState({}, '', href.split('#')[0]);
            }
            scrollTo($section);
          })
          .fail(function () {
            window.location.href = href;
          })
          .always(function () {
            $section.removeClass('is-loading');
          });
      }
    );

    $(document).on('click', section + ' .mu-js-col-load-more', function (e) {
      var $btn = $(this);
      var $list = $(section).find('#mu-items-list');
      if ($list.length === 0) {
        return;
      }

      e.preventDefault();

      var href = $btn.attr('href');
      var offset = parseInt($btn.data('offset'), 10) || 0;
      var step = parseInt($btn.data('step'), 10) || 12;
      var previousItemCount = $list.children().length;

      $btn.addClass('is-loading');

      $.get(withParams(href, { ajaxMore: 1, offset: offset }))
        .done(function (html, status, xhr) {
          $list.append(html);

          var $newItems = $list.children().slice(previousItemCount);
          if ($newItems.length > 0) {
            scrollTo($newItems.first());
          }

          var nextOffset = offset + step;
          $btn.data('offset', nextOffset);
          $btn.attr('href', withParams(href, { more: nextOffset + step }));

          if (xhr.getResponseHeader('X-Has-More') === '1') {
            $btn.removeClass('is-loading');
          } else {
            $btn.closest('.mu-meta__button').remove();
          }
        })
        .fail(function () {
          $btn.removeClass('is-loading');
        });
    });
  });

  // vlastní slider
  if ($('#mu-slider').length) {
    // hodnoty z data atributů
    var sliderMin = $('#mu-slider').data('min');
    var sliderMax = $('#mu-slider').data('max');
    // aktuální pozice
    var sliderMinSelected = $('#mu-slider').data('mins');
    var sliderMaxSelected = $('#mu-slider').data('maxs');
    // ošetření min/max pozice
    if (!sliderMinSelected) {
      sliderMinSelected = sliderMin;
    }
    if (!sliderMaxSelected) {
      sliderMaxSelected = sliderMax;
    }

    var slider = document.getElementById('mu-slider');

    noUiSlider.create(slider, {
      start: [sliderMinSelected, sliderMaxSelected],
      connect: true,
      step: 1,
      range: {
        min: sliderMin,
        max: sliderMax,
      },
    });

    var dateValues = [
      document.getElementById('mu-slider-min'),
      document.getElementById('mu-slider-max'),
    ];

    // aktualizace hodnot v inputech
    slider.noUiSlider.on('update', function (values, handle) {
      dateValues[handle].value = Math.ceil(values[handle]);
    });

    // odeslání formuláře po tažení
    slider.noUiSlider.on('set', function (values, handle) {
      sliderChecker();
    });
  }

  // odeslání formuláře po ruční změně
  $('#mu-slider-min').on('change', function () {
    sliderChecker();
  });
  $('#mu-slider-max').on('change', function () {
    sliderChecker();
  });

  // řešení odeslání formuláře po změně hodnot slideru
  function sliderChecker() {
    // hodnoty z data atributů
    var sliderMin = $('#mu-slider').data('min');
    var sliderMax = $('#mu-slider').data('max');
    // aktuální pozice
    var sliderMinSelected = $('#mu-slider').data('mins');
    var sliderMaxSelected = $('#mu-slider').data('maxs');
    // ošetření min/max pozice
    if (!sliderMinSelected) {
      sliderMinSelected = sliderMin;
    }
    if (!sliderMaxSelected) {
      sliderMaxSelected = sliderMax;
    }

    // nastavení stránkování na 1
    $('#strana').val(1);

    // hodnoty do skrytých polí (pro porovnání)
    var sliderMinActual = dateValues[0].value;
    var sliderMaxActual = dateValues[1].value;
    if (sliderMinSelected != sliderMinActual) {
      $('#datfset').val(sliderMinActual);
    }
    if (sliderMaxSelected != sliderMaxActual) {
      $('#dattset').val(sliderMaxActual);
    }

    // odeslání formuláře
    $('#sbirky').submit();
  }
});


//# sourceMappingURL=scripts.js.map
